import { useQuery } from '@tanstack/react-query'
import React from 'react'

import { type CoreMember } from './useMainQuery'
import { useMainQueryKey } from './useMainQueryKey'

export const useMainQueryCoreMembers = () => {
  const queryKey = useMainQueryKey()
  const { data } = useQuery<CoreMember[]>({ enabled: false, queryKey })

  return React.useMemo(() => data ?? [], [data])
}
